export default {
	HEADER: 1068,
	DESKTOP: 992,
	TABLET: 768,
	PHONE: 376,
};
